import { jsx as _jsx } from "react/jsx-runtime";
import AlternativeIcon from "../dislike-outlined";
const ThumbsDown = () => _jsx(AlternativeIcon, {});
ThumbsDown.iconName = "thumbsdown";
ThumbsDown.iconCategory = AlternativeIcon.iconCategory;
ThumbsDown.changed = true;
ThumbsDown.alternative = AlternativeIcon.iconName;
export default ThumbsDown;
